function resizeVideo(){
  document.querySelectorAll('.video-player').forEach(el =>{
    const rect = el.getBoundingClientRect();
    el.style.height = Math.round(rect.width * (9 / 16)) +'px';
  })
}

function getCILanguage(){
  const selector = document.getElementById('ci');
  const voice = selector.value;
  switch (voice){
    case "english":
      return "en";
    case "mandarin":
      return "sc"
    case "cantonese":
      return "tc"
    case "portuguese":
      return "pt";
    case "italian":
      return "it";
    default:
      return 'org';
  }
}

(fn => (document.readyState !== 'loading') ? fn() : document.addEventListener('DOMContentLoaded', fn))(()=>{
  window.addEventListener('resize', resizeVideo);
  resizeVideo();
  setTimeout(resizeVideo, 500);

  //sometime the video need to tap again to start play.
  //this script to auto tap in every 2 sec before start play
  let vo = getCILanguage();
  let retry = 0;

  const v = videojs('my-video');
  let playOnce = false;
  v.on('play', ()=>{
    if(playOnce)return;
    setTimeout(function(){
      if(v.played().length > 0)playOnce = true;
      try{
        v.pause();
        v.play();
      }catch(e){}
    }, 2000);
  });

  let tid = 0;

  const changeVoice = (voice) => {
    document.getElementById('ci-select').setAttribute('data-voice', voice);

    switch (voice){
      case "english":
        vo = "en";
        break;
      case "mandarin":
        vo = "sc"
        break;
      case "cantonese":
        vo = "tc"
        break;
      case "portuguese":
        vo = "pt"
        break;
      case "italian":
        vo = "it"
        break;
      default:
        vo = 'org';
    }

    const src = window.videofeed[vo];
    console.log(src);

    v.pause();

    v.src({
      src
    });

    v.play();
  }

  const selectors = document.querySelectorAll('.ci-select-links a');
  selectors.forEach(el => {
    el.addEventListener('click', (ev)=>{
      ev.preventDefault();
      clearTimeout(tid);
      const voice = el.getAttribute('data-voice');
      changeVoice(voice);
    });
  });
})